import { api } from "@/lib/api";

// Carica un PDF/foto a pezzi e fa leggere le righe all'AI (stesso motore del preventivo concorrente).
export async function leggiPreventivoAI(file, onProgress = () => {}) {
  if (file.size > 100 * 1024 * 1024) throw new Error("File troppo grande (max 100 MB)");
  const CH = 4 * 1024 * 1024;
  const total = Math.max(1, Math.ceil(file.size / CH));
  const uploadId = Array.from(crypto.getRandomValues(new Uint8Array(12))).map((b) => b.toString(16).padStart(2, "0")).join("");
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("upload_id", uploadId); fd.append("index", String(i)); fd.append("total", String(total));
    fd.append("chunk", file.slice(i * CH, (i + 1) * CH), "chunk");
    await api.post("/import-concorrente/chunk", fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress(Math.round(((i + 1) / total) * 100));
  }
  const { data } = await api.post("/import-concorrente/analizza-upload", { upload_id: uploadId, filename: file.name, content_type: file.type });
  for (let i = 0; i < 60; i++) {
    await new Promise((r) => setTimeout(r, 3000));
    const { data: job } = await api.get(`/import-concorrente/jobs/${data.job_id}`);
    if (job.stato === "completato") return job.result;
    if (job.stato === "errore") throw new Error(job.errore || "Lettura non riuscita");
  }
  throw new Error("L'analisi sta impiegando troppo: riprova");
}
